import { render, staticRenderFns } from "./CodePerdantView.vue?vue&type=template&id=98608dfc&scoped=true"
import script from "./CodePerdantView.vue?vue&type=script&lang=js"
export * from "./CodePerdantView.vue?vue&type=script&lang=js"
import style0 from "./CodePerdantView.vue?vue&type=style&index=0&id=98608dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98608dfc",
  null
  
)

export default component.exports